<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentAddOrganization /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentAddOrganization from '@/components/team/dashboard/modules/users/organization/ContentAddOrganization.vue'

export default 
{
  name: 'AddOrganization',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentAddOrganization
  }
}
</script>
<style>
</style>
